import { Button, CircularProgress, InputAdornment, TextField } from '@material-ui/core';
import { CompassIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';
import clsx from 'clsx';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { withBeneficiaryQuery } from '../../../Redesign/Tests/shared/adminResultNav';
import { AssignmentResourceFilter } from '../assignmentVisibility';
import { useStyles } from '../styles';
import { TestResultRow, useTestResults } from '../useTestResults';

interface TestResultsTabProps {
  user: any;
  assignmentFilter?: AssignmentResourceFilter | null;
  assignmentFilterReady?: boolean;
}

const TestsTable: FC<{
  title: string;
  rows: TestResultRow[];
  showViewTest?: boolean;
  onOpenResult: (path: string) => void;
}> = ({ title, rows, showViewTest = false, onOpenResult }) => {
  const classes = useStyles();
  const history = useHistory();

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className={classes.resultsSection}>
      <h2 className={classes.resultsSectionTitle}>{title}</h2>
      <div className={classes.tableWrap}>
        <table className={clsx(classes.table, classes.resourceTable)}>
          <colgroup>
            <col className={classes.colTestName} />
            <col className={classes.colTestDate} />
            <col className={classes.colTestAction} />
          </colgroup>
          <thead>
            <tr>
              <th className={classes.thLeft}>Test</th>
              <th className={classes.thLeft}>Date</th>
              <th className={classes.thLeft}>Résultat</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id}>
                <td className={classes.nameCell} title={row.name}>
                  {row.name}
                </td>
                <td>{row.date}</td>
                <td className={classes.testResultCell}>
                  <div className={classes.testResultActions}>
                    {/* {showViewTest && row.viewPath ? (
                      <Button
                        className={classes.testResultBtn}
                        onClick={() => history.push(row.viewPath as string)}>
                        Voir le test
                      </Button>
                    ) : null} */}
                    <Button
                      className={classes.testResultBtn}
                      onClick={() => onOpenResult(row.resultPath)}>
                      Consulter
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TestResultsTab: FC<TestResultsTabProps> = ({
  user,
  assignmentFilter = null,
  assignmentFilterReady = true,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const page = useTestResults(user, assignmentFilter, assignmentFilterReady);
  const hasVisibleRows = page.majorRows.length > 0 || page.minorRows.length > 0;

  const openResult = (path: string) => {
    history.push(withBeneficiaryQuery(path, user?.id));
  };

  return (
    <>
      <div className={classes.resultsToolbar}>
        <TextField
          className={classes.resultsSearch}
          variant="outlined"
          placeholder="Rechercher"
          value={page.search}
          onChange={event => page.setSearch(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MagnifyingGlassIcon size={20} color="#8B90A5" />
              </InputAdornment>
            ),
          }}
        />
        <Button
          className={classes.compassBtn}
          startIcon={<CompassIcon size={18} weight="regular" />}
          onClick={() => history.push(page.compassPath)}>
          Voir la boussole
        </Button>
      </div>

      {page.loading ? (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      ) : hasVisibleRows ? (
        <>
          <TestsTable title="Tests majeurs" rows={page.majorRows} onOpenResult={openResult} />
          <TestsTable
            title="Tests mineurs"
            rows={page.minorRows}
            showViewTest={true}
            onOpenResult={openResult}
          />
        </>
      ) : (
        <p className={classes.emptyTab}>
          {page.search.trim() && page.hasAnyResult
            ? `Aucun test ne correspond à votre recherche « ${page.search.trim()} ».`
            : 'Aucun test passé pour ce bénéficiaire.'}
        </p>
      )}
    </>
  );
};

export default TestResultsTab;
